module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-down-right-ccebc9427f1853c1b5f7b776b0799a97.svg";